(() => {
  'use strict';

  const SELECTOR_TEMPLATE = '[data-video-template]';
  const CLASS_LOADING = 'is-loading';
  const ATTR_VIDEO_ID = 'data-video-id';
  const ATTR_DEFER_UNTIL_LOAD = 'data-defer-until-load';

  if (customElements.get('video-background')) return;

  customElements.define(
    'video-background',
    class extends HTMLElement {
      constructor() {
        super();
        this.video = null;
        this.videoTemplateObserver = null;
        this.videoPlayObserver = null;
        this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
        this.startWhenReady = this.startWhenReady.bind(this);
      }

      connectedCallback() {
        this.videoId = this.getAttribute(ATTR_VIDEO_ID);
        this.videoTemplate = this.querySelector(SELECTOR_TEMPLATE);
        this.deferUntilLoad = this.hasAttribute(ATTR_DEFER_UNTIL_LOAD);

        if (!this.videoId || !this.videoTemplate) return;

        if (this.deferUntilLoad) {
          if (document.readyState === 'complete') {
            this.startWhenReady();
          } else {
            window.addEventListener('load', this.startWhenReady, { once: true });
          }
          return;
        }

        this.renderVideo();
      }

      startWhenReady() {
        this.renderVideo();
      }

      powerSaverVideoPlay() {
        this.video?.play();
      }

      renderVideo() {
        this.videoTemplateObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const html = this.videoTemplate.innerHTML;
              this.innerHTML = html;
              this.classList.remove(CLASS_LOADING);
              this.video = this.querySelector('video');
              this.observeVideoPlayToggle();

              this.video
                ?.play()
                .then(() => {})
                .catch(() => {
                  document.addEventListener('click', this.powerSaverVideoPlay, {
                    passive: true,
                    bubbles: true,
                    once: true,
                  });
                  document.addEventListener('touchstart', this.powerSaverVideoPlay, {
                    passive: true,
                    bubbles: true,
                    once: true,
                  });
                });

              observer.unobserve(entry.target);
            });
          },
          {
            root: null,
            rootMargin: '300px',
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
          }
        );

        this.videoTemplateObserver.observe(this);
      }

      observeVideoPlayToggle() {
        if (!this.video) return;

        this.videoPlayObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isVisible = entry.isIntersecting;
              if (isVisible && typeof this.video.play === 'function') {
                const playPromise = this.video.play();
                if (playPromise !== undefined) {
                  playPromise.then(() => {}).catch(() => {});
                }
              } else if (!isVisible && typeof this.video.pause === 'function') {
                this.video.pause();
              }
            });
          },
          { rootMargin: '0px', threshold: [0, 1] }
        );

        this.videoPlayObserver.observe(this.video);
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.startWhenReady);
        this.videoTemplateObserver?.disconnect();
        this.videoPlayObserver?.disconnect();

        if (this.videoId) {
          document.removeEventListener('click', this.powerSaverVideoPlay);
          document.removeEventListener('touchstart', this.powerSaverVideoPlay);
        }
      }
    }
  );
})();
